import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import Header from '../components/Header';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { useAuth } from '../context/AuthContext';

const { FiLock, FiAlertCircle } = FiIcons;

const ToolGate = () => {
  const { slug } = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [hasAccess, setHasAccess] = useState(false);
  const [toolContent, setToolContent] = useState(null);

  useEffect(() => {
    checkAccess();
  }, [slug, user]);

  const checkAccess = async () => {
    try {
      setLoading(true);
      
      // TODO: Serverseitige Zugriffsprüfung implementieren
      // Platzhalter für Demo
      const mockAccess = slug === 'tool-1' || slug === 'tool-2';
      setHasAccess(mockAccess);

      if (mockAccess) {
        // TODO: Tool-Inhalt vom Server laden
        setToolContent({
          name: `Tool: ${slug}`,
          description: 'Hier wird das Tool geladen und angezeigt.',
          content: 'Tool-Inhalt wird hier eingebettet...'
        });
      }
    } catch (error) {
      console.error('Fehler bei der Zugriffsprüfung:', error);
      setHasAccess(false);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-[var(--color-light)]">
        <Header />
        <div className="flex items-center justify-center h-[calc(100vh-4rem)]">
          <div className="text-center">
            <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-[var(--color-primary)] mx-auto mb-4"></div>
            <p className="text-[var(--color-text-light)]">Zugriff wird geprüft...</p>
          </div>
        </div>
      </div>
    );
  }

  if (!hasAccess) {
    return (
      <div className="min-h-screen bg-[var(--color-light)]">
        <Header />
        <div className="flex items-center justify-center h-[calc(100vh-4rem)]">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            className="max-w-md w-full mx-4"
          >
            <div className="bg-white rounded-xl shadow-lg p-8 text-center">
              <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <SafeIcon icon={FiLock} className="text-4xl text-[var(--color-error)]" />
              </div>
              <h2 className="text-2xl font-bold text-[var(--color-text-dark)] mb-4">
                Zugriff verweigert
              </h2>
              <p className="text-[var(--color-text-light)] mb-6">
                Sie haben keine Berechtigung für dieses Tool. Bitte kontaktieren Sie den Support oder erwerben Sie Zugriff.
              </p>
              <button
                onClick={() => navigate('/portal')}
                className="btn-primary w-full"
              >
                Zurück zum Portal
              </button>
            </div>
          </motion.div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[var(--color-light)]">
      <Header />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div className="bg-white rounded-xl shadow-sm p-8">
            <h1 className="text-3xl font-bold text-[var(--color-text-dark)] mb-4">
              {toolContent?.name}
            </h1>
            <p className="text-[var(--color-text-light)] mb-8">
              {toolContent?.description}
            </p>

            <div className="border-2 border-dashed border-[var(--color-border)] rounded-xl p-12 text-center">
              <SafeIcon icon={FiAlertCircle} className="text-6xl text-[var(--color-text-light)] mx-auto mb-4" />
              <p className="text-[var(--color-text-light)] text-lg">
                {toolContent?.content}
              </p>
              <p className="text-sm text-[var(--color-text-light)] mt-4">
                Hinweis: Hier wird das Tool aus /private-tools/{slug}/ geladen und eingebettet.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default ToolGate;